import { useEffect, useRef, useState } from 'react';
import { chargerFacturation } from './billing.js';

const TENTATIVES = 8;
const ATTENTE_MS = 1000;
const patienter = (ms) => new Promise((r) => setTimeout(r, ms));

/**
 * Retour du paiement Stripe — le même dans les quatre produits.
 *
 * Stripe ramène le client AVANT que le webhook ait forcément écrit
 * l'abonnement au portail. On relit donc l'état quelques secondes ; dès que
 * l'abonnement apparaît, `onConfirmed` renouvelle le jeton de l'appelant (les
 * droits y voyagent : sans cela les menus resteraient ceux d'avant le
 * paiement), puis on part vers `destination`.
 *
 * App n'avait pas cet écran (retour direct sur son profil, sans attendre la
 * confirmation), Compta et Previ l'avaient sans renouveler le jeton, Immo
 * l'avait complet : c'est la version d'Immo, rendue commune.
 */
export function PaiementRetour({
  apiUrl,
  getToken,
  product,
  spaceId = null,
  destination,
  abonnementHref = '/abonnement',
  onConfirmed,
}) {
  const [etat, setEtat] = useState('attente');
  const lance = useRef(false);

  useEffect(() => {
    if (lance.current) return;
    lance.current = true;
    void (async () => {
      try {
        for (let i = 0; i < TENTATIVES; i += 1) {
          const f = await chargerFacturation(apiUrl, getToken, spaceId);
          const ligne = f?.subscriptions?.find((s) => s.product === product);
          if (ligne && ligne.status !== 'CANCELED' && ligne.source !== 'GIFT') {
            await onConfirmed?.();
            window.location.replace(destination);
            return;
          }
          await patienter(ATTENTE_MS);
        }
        setEtat('incomplet');
      } catch (e) {
        console.error('[abonnement] retour de paiement :', e);
        setEtat('erreur');
      }
    })();
  }, [apiUrl, getToken, product, destination, onConfirmed]);

  if (etat === 'attente') {
    return (
      <section className="abonnement">
        <h1>Finalisation de votre abonnement…</h1>
        <p role="status">Nous attendons la confirmation du paiement.</p>
      </section>
    );
  }
  return (
    <section className="abonnement">
      <h1>{etat === 'incomplet' ? 'Paiement en cours de traitement' : 'Une erreur est survenue'}</h1>
      <p>
        {etat === 'incomplet'
          ? 'La confirmation n’est pas encore arrivée ; elle prend parfois quelques instants. '
          : 'Impossible de vérifier votre abonnement. '}
        Consultez <a href={abonnementHref}>Mon abonnement</a> dans un moment.
      </p>
    </section>
  );
}
